<template>
  <!-- eslint-disable vue/valid-v-slot -->
  <v-dialog
    max-width="800px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    v-model="show"
    :persistent="false"
    v-on:click:outside="cancel"
  >
    <v-card class="rounded-card" height="20%" elevation="0">
      <v-system-bar color="orange lighten-1" height="60px">
        <span class="headline font-weight-bold ms-2"> {{ title }} </span>
      </v-system-bar>
      <v-row class="mx-0" dense>
        <v-col col="12" sm="3" class="ps-4">
          <v-text-field
            :label="$t('Recipe Code')"
            v-model="recipe.code"
            readonly class="pb-0"
            :color="isNewRecipe ? 'grey' : 'snow'"
          ></v-text-field>
        </v-col>
        <v-col col="12" sm="6">
          <v-text-field
            :label="$t('Recipe Name')"
            class="pb-0"
            v-model="recipe.name"
            validate-on-blur
          ></v-text-field>
        </v-col>
        <v-col col="12" sm="2" offset-sm="1" class="">
          <v-switch
            :label="$t('Archive')"
            v-bind="recipe.archive"
            class="ps-1 pb-0"
          ></v-switch>
        </v-col>
      </v-row>
      <v-row class="mx-0" dense>
        <v-col col="12" sm="6">
          <v-text-field
            :label="$t('Source')"
            v-model="recipe.source"
            readonly
            class="pb-0"
          ></v-text-field>
        </v-col>
        <v-col col="12" sm="6">
          <v-select
            :items="dropdown_target_group"
            item-value="value"
            :label="$t('Target Group')"
            v-model="recipe.targetGroup"
            class="pb-0"
          ></v-select>
        </v-col>
      </v-row>
      <v-row class="mx-0" dense>
        <v-col col="12">
          <v-textarea
              :label="$t('Notes')"
              v-model="recipe.notes"
              class="pb-0"
              auto-grow dense rows="2"
            ></v-textarea>
        </v-col>
      </v-row>
      <v-card-actions class="py-0 ms-2 me-6">
         <v-tooltip top v-if="!isNewRecipe">
            <template v-slot:activator="{on}">
              <v-btn icon large color="primary" v-on="on" @click.stop="DeleteRecipe" class="me-6">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>{{$t('Delete this recipe')}}</span>
          </v-tooltip>

          <v-tooltip top v-if="!isNewRecipe">
            <template v-slot:activator="{on}">
              <v-btn icon large color="primary" v-on="on" @click.stop="DupRecipe" class="mx-4">
                <v-icon>mdi-content-duplicate</v-icon>
              </v-btn>
            </template>
            <span>{{$t('Duplicate this recipe')}}</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-btn icon large color="primary" v-on="on" @click.stop="csvExport" class="mx-4">
                <v-icon>mdi-file-delimited</v-icon>
              </v-btn>
            </template>
            <span>{{$t('Save to delimited file')}}</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-btn icon large color="primary" v-on="on" @click.stop="printRecipe" class="mx-4">
                <v-icon>mdi-printer</v-icon>
              </v-btn>
            </template>
            <span>{{$t('print this recipe')}}</span>
          </v-tooltip>

        <v-spacer />
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon large color="primary" v-on="on" @click.stop="cancel" class="mx-4">
              <v-icon>mdi-cancel</v-icon>
            </v-btn>
          </template>
          <span>{{
            $t("Cancel") + " (" + $t("exit without saving") + ")"
          }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon large color="primary" v-on="on" @click.stop="save" class="mx-4">
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Save") }}</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
    <!-- <v-row justify="center" dense> -->
    <!-- <v-col cols="12"> md="10" lg="8" xl="7"> -->
    <v-data-table
      :headers="headers"
      :items="recipe.nutrition"
      :items-per-page="30"
      dense
      class="headline scroll-v-only pt-4"
      hide-default-footer
      hide-default-header
      @click:row="editItem"
      fixed-header
      height="440px"
    >
      <template v-slot:item.actions="{ item }">
        <v-icon small class="pe-4 primary--text" @click="editItem(item)">
          mdi-pencil
        </v-icon>
      </template>
      <template v-slot:header="{ props: { headers } }">
        <thead>
          <tr>
            <th
              v-for="hdr in headers"
              :key="hdr.index"
              class="subtitle-2 font-weight-medium primary--text text--lighten-1"
              :class="{
                'text-end': hdr.align == 'end',
                'text-center': hdr.align == 'center',
                'ps-6': hdr.value == 'consider',
              }"
            >
              {{ hdr.text.toUpperCase() }}
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:item.consider="{ item }">
        <v-simple-checkbox disabled :value="item.consider" class="ps-5 py-2">
        </v-simple-checkbox>
      </template>
      <template v-slot:top>
        <v-dialog
          v-model="editDialog"
          max-width="500px"
          transition="scale-transition"
          origin="center center"
        >
          <v-card elevation="8" outlined >
            <v-card-title>
              <span class="headline pe-2 primary--text">{{
                editedItem.name
              }}</span>
              <span class="subtitle-2 pt-2 primary--text">{{
                "(" + editedItem.unit + ")"
              }}</span>
            </v-card-title>

            <v-card-text class="py-0">
              <v-container>
                <v-row dense>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      type="number"
                      v-model="editedItem.min"
                      :label="$t('Minimum')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      type="number"
                      v-model="editedItem.max"
                      :label="$t('Maximum')"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="editedItem.tolerance"
                      :label="$t('Tolerance')"
                    ></v-text-field>
                  </v-col> -->
                  <v-col cols="12" sm="3" offset-sm="1">
                    <v-checkbox
                      v-model="editedItem.consider"
                      :label="$t('Use')"
                      color="snow"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon large color="primary" v-on="on" @click.stop="closeItem" class="mx-4">
                    <v-icon>mdi-cancel</v-icon>
                  </v-btn>
                </template>
                <span>{{
                  $t("Cancel") + " (" + $t("exit without saving") + ")"
                }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon large color="primary" v-on="on" @click.stop="saveItem" class="mx-4">
                    <v-icon>mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("Save") }}</span>
              </v-tooltip>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </v-data-table>
    <!-- </v-row> -->
  </v-dialog>
</template>

<script>
import _ from "lodash";
// import RecipePrint from "../components/RecipePrint"
const defaultItem = {
        name: "Unknown",
        unit: "",
        min: 0,
        max: 0,
        tolerance: 0,
        consider: true
}
export default {
  name: "RecipeTable",
  props: {
    value: Boolean,
    recipeId: String
  },
  data() {
    return {
      recipe: {},
      editDialog: false,
      editedIndex: -1,
      editedItem: defaultItem,
      headers: [
        { text: this.$i18n.t("Use"),  align: "start",  sortable: false,  width: "8%",  value: "consider",  class: "table-header-class",},
        { text: this.$i18n.t("Nutrition"),  align: "start",  sortable: true,  width: "30%",  value: "name",  class: "table-header-class",},
        { text: this.$i18n.t("Unit"),  align: "start",  sortable: false,  width: "8%",  value: "unit",  class: "table-header-class",},
        { text: this.$i18n.t("Minimum"),  align: "end",  sortable: false,  width: "17%",  value: "min",  class: "table-header-class",},
        { text: this.$i18n.t("Maximum"),  align: "end",  sortable: false,  width: "17%",  value: "max",  class: "table-header-class",},
        // { text: "Tolerance", align: "end", sortable: false, width: "15%", value: "tolerance", class: "table-header-class", },
        { text: "",  value: "actions",  sortable: false,  width: "20%",  align: "end",  class: "table-header-class",}
      ]
    };
  },
  mounted () {
    if (this.recipeId)
      this.recipe = _.cloneDeep(this.$store.getters.getRecipe(this.recipeId));
    else
      this.recipe = _.cloneDeep(this.$store.getters.getRecipe());
  },
  activated () {
   // Fixme:console.log("Activated Event:" + this.recipeId);
  },
  computed: {
    isNewRecipe() {
      return !(this.recipe && this.recipe.id);
    },
    show: {
      get() {
        return this.value;
      },
      set() {
        this.close();
      },
    },
    title() {
      return this.isNewRecipe
        ? this.$i18n.t("New Recipe")
        : this.$i18n.t("Edit Recipe") +
            " " +
            this.recipe.code +
            " - " +
            this.recipe.name;
    },
    dropdown_target_group() {
      return this.$store.getters.getGroupTypesForDD;
    }
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.recipe.nutrition.indexOf(item);
      this.editedItem = Object.assign({}, item);
     // Fixme:console.log(`start editing item: ${item.name}`);
      this.editDialog = true;
    },
    save() {
        var payload = {id: this.recipeId,
                        ...this.recipe,
                        translatedTargetGroup: this.$i18n.t(this.recipe.targetGroup)
                      }
        this.$store.dispatch("saveRecipe", payload);
        this.$nextTick(() => this.$forceUpdate());
        this.close();
    },
    close() {
      this.$emit("close");
    },
    cancel() {
     // Fixme:console.log("Cancel Event:" + this.recipeId);
      if (this.recipeId)
        this.recipe = this.$store.getters.getRecipe(this.recipeId);
      else
        this.recipe = _.cloneDeep(this.$store.getters.getRecipe());
      this.close();

    },
    DeleteRecipe() {
      if (this.recipeId) {
        this.$root.$confirm(this.$i18n.t('Delete'), this.$i18n.t('Delete Recipe') +" " + this.recipe.code + "?", { color: "red" })
        .then((confirm) => {
          if (confirm) {
            this.$store.dispatch("deleteRecipe", this.recipeId);
            this.close();
          }
        });
      }
    },
    DupRecipe() {
      var newCode = this.$store.getters.getNextRecipeNo;
      var payload = { id: undefined,
                      ...this.recipe,
                      translatedTargetGroup: this.$i18n.t(this.recipe.targetGroup),
                      code: newCode
                    };
        this.$store.dispatch("saveRecipe", payload);
        this.$root.$globalSnackbar(this.$i18n.t('New Recipe Created', [newCode]), "success");
        this.close();
        this.$nextTick(() => this.$emit("switch-to", newCode));
    },
    printRecipe() {
      if (this.recipeId)
        this.$router.push( {
          name: 'RecipePrint',
          params: { id: this.recipeId }
        } );
      else
        this.$root.$globalSnackbar(this.$i18n.t('Recipe Must be saved, before printed'), "warning");
    },
    csvExport() {
      let csvContent = "data:text/csv;charset=utf-8,";
      let headerKeys = ["code", "name", "archive", "source", "translatedTargetGroup", "targetGroup"];
      let headerNames = ["Recipe Code", "Recipe Name", "Archive", "Source", "Target Group", "Target Group EN" ];
      let nutritionKeys = ["consider", "name", "unit", "min", "max"];
      let nutritionNames = ["Use", "Nutrition", "Unit", "Minimum", "Maximum"];
      let nutrition = this.recipe.nutrition;
      csvContent += headerNames.map(x=> this.$i18n.t(x)).join(", ") + "\n";
      csvContent += headerKeys.map(x => this.recipe[x]).join(", ") + "\n";
      csvContent += this.$i18n.t('Notes') +":, " + this.recipe.notes + "\n";
      csvContent += "\n\n";
      csvContent += nutritionNames.map(x=> this.$i18n.t(x)).join(", ") + "\n";
      csvContent += [...nutrition.map(item => nutritionKeys.map(x => item[x]).join(", "))].join("\n");
      csvContent = csvContent.replace(/[?@&$#]/g, '_');

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "recipe-"+ this.recipe.code + ".csv");
      link.click();
    },
    saveItem() {
      if (this.editedIndex > -1) {
        if (this.editedItem.min > this.editedItem.max) {
          this.$root.$globalSnackbar(this.$i18n.t('min less then max'), "error");
          return;
        }
        Object.assign(this.recipe.nutrition[this.editedIndex], this.editedItem);
      }
      this.editDialog = false;
    },
    closeItem() {
      this.editDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
};
</script>

<style>
.scroll-v-only {
  overflow-y: auto;
  overflow-x: hidden !important;
}
.slight-rounded {
   border-radius:4px;
}
</style>